export default {
    'next': 'Next',
    'complete': 'Complete',
    'submit': 'Submit',
    'resubmit': 'Resubmit',
    'reset': 'Reset',
    'correct': 'Correct',
    'hint': 'Hint',
    'simplest_structure': 'Simplest Structure'
};



// WEBPACK FOOTER //
// ./client/app/core/i18n/basic/en.js